module.exports = __webpack_public_path__ + "static/media/up-main-banner.b133d81d.png";